module.exports = __webpack_public_path__ + "static/media/above-the-trees-text.56015898.png";